import { library } from '@fortawesome/fontawesome-svg-core'

import {
   faTwitter,
   faFontAwesome,
   faInstagram,
   faFacebook,
   faGoogle,
} from '@fortawesome/free-brands-svg-icons'

import {
   faEnvelope,
   faUser as farUser,
   faAddressBook,
   faChessPawn,
   faAddressCard,
   faBuilding,
   faRectangleList,
   faHospital,
   faMap as farMap,
   faCircleXmark,
} from '@fortawesome/free-regular-svg-icons'

import {
   faUser as fasUser,
   faLock,
   faChevronRight,
   faMap as fasMap,
   faLocation,
   faSuitcaseMedical,
   faHouse,
   faCheck,
   faPlus,
} from '@fortawesome/free-solid-svg-icons'

library.add(
   faTwitter,
   faFontAwesome,
   fasUser,
   farUser,
   faLock,
   faChevronRight,
   faInstagram,
   faEnvelope,
   faFacebook,
   faGoogle,
   faAddressBook,
   faChessPawn,
   faAddressCard,
   faBuilding,
   faRectangleList,
   faHospital,
   farMap,
   faCircleXmark,
   fasMap,
   faLocation,
   faSuitcaseMedical,
   faHouse,
   faCheck,
   faPlus
)
